export { isArray, isArrayLike, toArray, uniq, union, sortedIndex, sortedIndexBy, sortBy, groupBy, difference, without, } from 'lodash-es';
const proto = Array.prototype;
export function slice(arr, start, end) {
    return arr ? proto.slice.call(arr, start, end) : [];
}
export function indexOf(arr, item) {
    return arr ? proto.indexOf.call(arr, item) : -1;
}
export function includes(arr, item) {
    return arr ? indexOf(arr, item) >= 0 : false;
}
export function lastIndexOf(arr, item) {
    return arr ? proto.lastIndexOf.call(arr, item) : -1;
}
export function map(arr, iterator, thisArg) {
    return arr ? proto.map.call(arr, iterator, thisArg) : [];
}
export function some(arr, iterator, thisArg) {
    return arr ? proto.some.call(arr, iterator, thisArg) : false;
}
export function every(arr, iterator, thisArg) {
    return arr ? proto.every.call(arr, iterator, thisArg) : false;
}
export function filter(arr, iterator, thisArg) {
    return arr ? proto.filter.call(arr, iterator, thisArg) : [];
}
export function forEach(arr, iterator, thisArg) {
    arr && proto.forEach.call(arr, iterator, thisArg);
}
export function reduce(arr, iterator, initialValue) {
    return arr ? proto.reduce.call(arr, iterator, initialValue) : initialValue;
}
export function reduceRight(arr, iterator, initialValue) {
    return arr
        ? proto.reduceRight.call(arr, iterator, initialValue)
        : initialValue;
}
//# sourceMappingURL=array.js.map